import { useMutation, useQueryClient } from '@tanstack/react-query';
import { manufacturerApi } from '@entities/manufacturer';
import { useToast } from '@shared/ui';
import type { UUID } from '@shared/api';

export function useApproveKyc(id: UUID) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: () => manufacturerApi.approveKyc(id),
    onSuccess: () => {
      toast.success('KYC одобрен');
      void qc.invalidateQueries({ queryKey: ['manufacturer', id] });
      void qc.invalidateQueries({ queryKey: ['manufacturers'] });
    },
    onError: (e: Error) => toast.error('Не удалось одобрить KYC', e.message),
  });
}

export function useRejectKyc(id: UUID) {
  const qc = useQueryClient();
  const toast = useToast();
  return useMutation({
    mutationFn: (reason: string) => manufacturerApi.rejectKyc(id, reason),
    onSuccess: () => {
      toast.success('KYC отклонён');
      void qc.invalidateQueries({ queryKey: ['manufacturer', id] });
      void qc.invalidateQueries({ queryKey: ['manufacturers'] });
    },
    onError: (e: Error) => toast.error('Не удалось отклонить KYC', e.message),
  });
}
